<div fxFlex="100%" fxLayout="column" class="p-8 h-100-p w-100-p">

  <div fxFlex>
    <h4>Add credits to selected Contributors</h4>
  </div>

  <div fxFlex fxLayout fxLayoutAlign="end center" class="p-4">
    <span fxFlex="grow">Amount</span>
    <dx-number-box
      format="$ #,##0.##"
      [formControl]="fEditExt.get(['amount'])"
    ></dx-number-box>
  </div>

  <div fxFlex="grow" fxLayout class="p-4">
    <mat-form-field class="w-100-p" appearance="fill">
      <mat-label>Message</mat-label>
      <textarea matInput placeholder="Just say something nice...." [formControl]="fEditExt.get(['message'])"></textarea>
    </mat-form-field>
  </div>

  <div fxFlex>
    <span fxFlex="auto"></span>
    <button mat-stroked-button [disabled]="fEditExt.invalid" (click)="addCredits()">[Add credits]</button>
  </div>

</div>
